import React from 'react';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import useAudioServerCommunication from './useAudioServerCommunication';

export default function useHandleSessionTermination() {
  const { sessionId: [sessionId, setSessionId], terminating: [terminating, setTerminating] } = useSessionStoreContext();
  const sessionIdRef = React.useRef<string | null>(sessionId);
  const { lastJsonMessage } = useAudioServerCommunication();

  React.useEffect(() => {
    if (!sessionId) {
      setTerminating(null);
    }
    sessionIdRef.current = sessionId;
  }, [sessionId]);

  React.useEffect(() => {
    if (terminating && lastJsonMessage && lastJsonMessage.type) {
      switch (lastJsonMessage.type) {
        case 'endSessionAck':
          if (terminating === lastJsonMessage.sessionId) {
            setSessionId(null);
            setTerminating(null);
          }
          break;

        default:
          break;
      }
    }
  }, [terminating, lastJsonMessage]);

  React.useEffect(() => {
    if (terminating) {
      const timeout = setTimeout(() => {
        if (terminating === sessionIdRef.current) {
          // setAudioWebsocketConnectionEnabled(false); TODO: check how we do this.
          setSessionId(null);
          setTerminating(null);
        }
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    }
    return undefined;
  }, [terminating, sessionIdRef]);
}
